var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgCalendar(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("defs", null, React.createElement("path", {
    id: "calendar_svg__a",
    d: "M0 0h18.25v20.249H0z"
  })), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(7 6)"
  }, React.createElement("mask", {
    id: "calendar_svg__b",
    fill: "#fff"
  }, React.createElement("use", {
    xlinkHref: "#calendar_svg__a"
  })), React.createElement("path", {
    fill: "currentColor",
    d: "M17.406 2.001v1.883H.844L.842 2.021l.004-.038a.061.061 0 01.057-.039h.807v.624l.008.112c.061.44.444.771.894.771l.279-.001.113-.008a.897.897 0 00.779-.883v-.615h1.116v.624l.008.112c.061.44.444.771.894.771l.279-.001.113-.008a.897.897 0 00.779-.883v-.615h1.116l.001.623.007.113c.061.44.445.771.893.771l.28-.001.113-.008a.897.897 0 00.779-.883v-.615h1.116l.001.623.007.113c.061.44.445.771.893.771l.28-.001.113-.008a.897.897 0 00.779-.883v-.615h1.116l.001.623.007.113c.061.44.445.771.893.771l.28-.001.113-.008a.897.897 0 00.779-.883v-.615l.788-.002.039.005c.02.007.04.026.04.054zm-1.713.576a.059.059 0 01-.055.038l-.251.001-.038-.004a.055.055 0 01-.039-.053L15.308.911l.004-.037a.06.06 0 01.055-.039h.271c.032 0 .058.025.058.056l.002 1.647-.005.039zm-3.189 0a.059.059 0 01-.055.038l-.251.001-.038-.004a.055.055 0 01-.039-.053L12.119.911l.005-.037a.057.057 0 01.054-.039h.271c.032 0 .058.025.058.056l.001 1.648-.004.038zM8.93.911l.005-.037a.057.057 0 01.054-.039h.271c.032 0 .058.025.058.056l.001 1.648-.004.038a.059.059 0 01-.055.038l-.25.001-.039-.004a.057.057 0 01-.039-.053L8.93.911zm-3.189 0l.004-.037a.061.061 0 01.056-.039h.27c.032 0 .058.025.058.056l.001 1.648-.004.037a.059.059 0 01-.055.039l-.25.001-.039-.004a.058.058 0 01-.04-.053L5.741.911zm-3.189 0l.004-.037a.06.06 0 01.056-.039h.27c.032 0 .058.025.058.056l.001 1.648-.004.037a.059.059 0 01-.055.039l-.251.001-.038-.004a.058.058 0 01-.04-.053L2.552.911zM.843 13.341l.001-8.622 16.562.001.001 14.616-.004.038a.06.06 0 01-.057.04l-16.423.001-.04-.004a.059.059 0 01-.039-.055l-.001-2.423.007.001v-3.476l-.007-.117zM18.249 1.992l-.008-.112a.902.902 0 00-.895-.772h-.807L16.531.77a.902.902 0 00-.893-.77h-.279l-.113.008a.898.898 0 00-.78.883v.217H13.35L13.343.77a.903.903 0 00-.894-.77h-.279l-.113.008a.898.898 0 00-.78.883v.217h-1.116L10.154.77A.903.903 0 009.26 0h-.279l-.114.008a.897.897 0 00-.779.883v.217H6.972L6.965.77A.903.903 0 006.071 0h-.279l-.114.008a.897.897 0 00-.779.883v.217H3.783L3.775.77A.9.9 0 002.882 0h-.279l-.114.008a.897.897 0 00-.779.883v.217H.895l-.114.008A.9.9 0 000 2.001v17.364l.008.113c.061.44.445.771.895.771h16.452l.113-.008a.899.899 0 00.782-.885l-.001-17.364z",
    mask: "url(#calendar_svg__b)"
  })), React.createElement("path", {
    fill: "currentColor",
    d: "M13.156 16.217a.493.493 0 00.32-.112l.56-.396v4.836c0 .315.251.58.551.58.3 0 .551-.265.551-.58v-5.842c0-.315-.252-.579-.55-.579-.146 0-.233.051-.34.122l-1.392.945a.561.561 0 00-.232.467c0 .305.242.56.532.56m3.487-.001a.491.491 0 00.319-.112l.56-.396v4.836c0 .315.252.58.552.58.299 0 .55-.265.55-.58v-5.842c0-.315-.251-.579-.55-.579-.145 0-.232.051-.34.122l-1.39.945a.56.56 0 00-.233.467c0 .305.242.56.532.56"
  })));
}

export default SvgCalendar;